import { render } from "./ProductFixationCollectionPrevie.vue?vue&type=template&id=2a967485&scoped=true"
import script from "./ProductFixationCollectionPrevie.vue?vue&type=script&lang=js"
export * from "./ProductFixationCollectionPrevie.vue?vue&type=script&lang=js"

import "./ProductFixationCollectionPrevie.vue?vue&type=style&index=0&id=2a967485&lang=scss&scoped=true"

import exportComponent from "F:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a967485"]])

export default __exports__